import React from "react";
import CustomHeader from "../components/CustomHeader";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";

import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

function srcset(image, size, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${
            size * rows
        }&fit=crop&auto=format&dpr=2 2x`,
    };
}

const itemData = [
    {
        img: "gallery-preview/IMG_7175.jpeg",
        rows: 2,
        cols: 2,
    },
    {
        img: "gallery-preview/IMG_7111.jpeg",
        rows: 1,
    },
    {
        img: "gallery-preview/IMG_7089.jpeg",
        rows: 1,
    },
    {
        img: "gallery-preview/IMG_7290.jpeg",
        rows: 1,
        cols: 2,
    },
];

const PhotoGallery = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const gallery = (
        <ImageList
            sx={{ width: isMobile ? "90%" : "75%", height: "100%" }}
            variant="quilted"
            cols={isMobile ? 2 : 4}
            rowHeight={"auto"}
        >
            {itemData.map((item) => (
                <ImageListItem
                    key={item.img}
                    cols={item.cols || 1}
                    rows={item.rows || 1}
                >
                    <img
                        {...srcset(item.img, 121, item.rows, item.cols)}
                        alt={item.title}
                        loading="lazy"
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
    return (
        <div
            id="photo-gallery"
            style={{
                minHeight: "80vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ padding: "20px", maxWidth: isMobile ? "90%" : "70%" }}>
                <CustomHeader value="ADScAI Conference 2026 – Photo Gallery" />
            </div>
            <div
                style={{
                    width: isMobile ? "95%" : "75%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {gallery}
            </div>
            <div
                style={{
                    maxWidth: isMobile ? "90%" : "70%",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    alignItems: "center",
                    paddingBottom: "40px",
                }}
            >
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontWeight: 500, textAlign: "center" }}
                    gutterBottom
                >
                    We sincerely appreciate all participants and contributors who made the second ADScAI Conference 2026 a remarkable success at the University of Moratuwa, Sri Lanka. Your active involvement helped shape a vibrant platform for advancing data science and artificial intelligence.
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontWeight: 500, textAlign: "center" }}
                    gutterBottom
                >
                    As we reflect on this successful edition, we also look forward to future chapters of the ADScAI Conference. We hope these highlights inspire your continued involvement in the years to come.
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ fontWeight: 500, textAlign: "justify" }}
                >
                    The complete album from the second ADScAI 2026 conference will be available soon                    &nbsp;
                    {/*<Link*/}
                    {/*    href="https://www.facebook.com/share/17qUpf5VAh/"*/}
                    {/*    target="_blank"*/}
                    {/*    rel="noopener noreferrer"*/}
                    {/*>*/}
                    {/*    here*/}
                    {/*</Link>*/}
                </Typography>
            </div>
        </div>
    );
};

export default PhotoGallery;